export const messages = {
    "shared-link.footer.link.install": "Prova {brandName} gratis",
    "shared-link.footer.link.mobile": "{brandName} för mobil",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Skyddade data",
    "shared-link.password-dialog-box.message": "Ange lösenordet för att få åtkomst till delade data",
    "shared-link.password-dialog-box.hint.password": "Lösenord",
    "shared-link.password-dialog-box.message.invalid-password": "Lösenordet är felaktigt",
    "shared-link.form.button.open": "Öppna",
    "shared-link.page-not-found.title": "Sidan hittades inte",
    "shared-link.page-not-found.message.main": "Sidan du letar efter hittades inte.",
    "shared-link.page-not-found.message.description": "Länken kan vara utgången eller så kan du ha skrivit in fel adress.",
    "shared-link.page-not-found.message.error": "Felkod: 404",
    "shared-link.restore-file.label.size": "Storlek",
    "shared-link.restore-file.button.restore": "Hämta",
    "shared-link.links-table.column.name": "Namn",
    "shared-link.links-table.column.size": "Storlek",
    "shared-link.links-table.action.restore": "Hämta",
    "shared-link.links-table.action.restore-all": "Hämta alla",
    "shared-link.side-bar.selected.title:plural": "{count} valda artiklar | {count} vald artikel | {count} valda artiklar",
    "shared-link.links-table.label.size": "Storlek",
    "shared-link.links-table.message.empty-folder": "Mappen är tom"
};
